export interface OauthRedirectEnvironment {
  userAgent?: string;
  platform?: string;
  maxTouchPoints?: number;
}

function readNavigator(): OauthRedirectEnvironment {
  if (typeof navigator === "undefined") {
    return { userAgent: "", platform: "", maxTouchPoints: 0 };
  }
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints,
  };
}

/** True for real mobile browsers. Narrow desktop windows stay on the popup path. */
export function prefersOauthRedirect(input: OauthRedirectEnvironment = {}): boolean {
  const env = {
    ...readNavigator(),
    ...input,
  };
  const userAgent = env.userAgent ?? "";
  const platform = env.platform ?? "";
  const maxTouchPoints = env.maxTouchPoints ?? 0;

  if (/Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    return true;
  }
  if (/iPad/i.test(userAgent)) {
    return true;
  }
  return platform === "MacIntel" && maxTouchPoints > 1;
}
